// test1285
(1285 && 0);
